import { ChangeEvent, FC } from 'react'
import { useFormContext } from 'react-hook-form';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

// Interface for the Custom Checkbox Field props.
interface ICustomCheckbox {
    name: `${string}`;
    label: string;
    checked: boolean;
    onChange: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
}

/**
 * Custom Checkbox field component.
 */
const CustomCheckbox: FC<ICustomCheckbox> = ({name, label, checked, onChange, ...rest}) => {
    const { register } = useFormContext();

    return (
        <FormGroup>
            <FormControlLabel
                control={<Checkbox 
                    {...register(name)}
                    {...rest}
                    onChange={onChange}
                    checked={checked}
                />}
                label={label}
            />
        </FormGroup>
    )
}

export default CustomCheckbox;
